import * as React from 'react';

/* ── LiteDashboard icons ───────────────────────────────── */

export const SortChevronIcon = () => (
  <span className="th-chevron">
    <svg className="chev-up" width="8" height="5" viewBox="0 0 8 5">
      <path d="M1 4l3-3 3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
    <svg className="chev-dn" width="8" height="5" viewBox="0 0 8 5">
      <path d="M1 1l3 3 3-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  </span>
);

export const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9.5 9.5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const FilterIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M1 3h11M3 6.5h7M5 10h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const CopyIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <rect x="4" y="4" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M4 4V2.5A1.5 1.5 0 015.5 1H10.5A1.5 1.5 0 0112 2.5V7.5A1.5 1.5 0 0110.5 9H9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

export const DeleteIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M2 3.5h9M5 3.5V2.5h3v1M4 3.5l.5 7.5h4l.5-7.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PaginationPrevIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M6.5 2L3.5 5l3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PaginationNextIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M3.5 2l3 3-3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const NewProjectPlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

/* ── NewProjectModal icons ─────────────────────────────── */

export const SYSTEM_ICONS: Record<string, React.ReactNode> = {
  NXT: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2 15 L10 5 L18 15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="4" y1="12.5" x2="16" y2="12.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      <line x1="6" y1="10" x2="14" y2="10" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
  SM: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2 16 L10 7 L18 16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="5" y1="13" x2="15" y2="13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  RM10EVO: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="5" width="7" height="5" rx="1.2" fill="currentColor" opacity=".7"/>
      <rect x="11" y="5" width="7" height="5" rx="1.2" fill="currentColor"/>
      <rect x="2" y="12" width="7" height="5" rx="1.2" fill="currentColor" opacity=".5"/>
      <rect x="11" y="12" width="7" height="5" rx="1.2" fill="currentColor" opacity=".85"/>
    </svg>
  ),
  GF10D: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="5" width="4.5" height="4" rx="1" fill="currentColor" opacity=".6"/>
      <rect x="7.75" y="5" width="4.5" height="4" rx="1" fill="currentColor" opacity=".85"/>
      <rect x="13.5" y="5" width="4.5" height="4" rx="1" fill="currentColor"/>
      <rect x="2" y="11" width="4.5" height="4" rx="1" fill="currentColor"/>
      <rect x="7.75" y="11" width="4.5" height="4" rx="1" fill="currentColor" opacity=".7"/>
      <rect x="13.5" y="11" width="4.5" height="4" rx="1" fill="currentColor" opacity=".5"/>
    </svg>
  ),
  GF5D: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="5" width="7" height="4.5" rx="1.2" fill="currentColor" opacity=".85"/>
      <rect x="11" y="5" width="7" height="4.5" rx="1.2" fill="currentColor" opacity=".5"/>
      <rect x="2" y="11.5" width="7" height="4.5" rx="1.2" fill="currentColor" opacity=".6"/>
      <rect x="11" y="11.5" width="7" height="4.5" rx="1.2" fill="currentColor"/>
    </svg>
  ),
};

// Keys match the numeric roof_type values from projectConfiguration/fields/roofType.ts
// and rm5roofType.ts (e.g. 1=SHINGLE, 2=STANDING SEAM, 6=EPDM, 7=TPO, etc.)
export const ROOF_ICONS: Record<string, React.ReactNode> = {
  // Pitched
  '1': ( // SHINGLE
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2 14 L10 5 L18 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 14 L4 17 L16 17 L16 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="6" y1="10" x2="9" y2="10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="11" y1="10" x2="14" y2="10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="5" y1="12.5" x2="8" y2="12.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="10" y1="12.5" x2="15" y2="12.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  ),
  '2': ( // STANDING SEAM METAL
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2 15 L10 6 L18 15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="6" y1="9.5" x2="6" y2="15" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      <line x1="9" y1="7.5" x2="9" y2="15" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      <line x1="12" y1="8" x2="12" y2="15" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      <line x1="15" y1="10" x2="15" y2="15" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
  '3': ( // TILE
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2 15 L10 6 L18 15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 15 Q6.5 12 8 15" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round"/>
      <path d="M9 15 Q10.5 12 12 15" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round"/>
      <path d="M13 15 Q14.5 12 16 15" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round"/>
      <path d="M7 11.5 Q8.5 9 10 11.5" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round"/>
      <path d="M11 11.5 Q12.5 9 14 11.5" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round"/>
    </svg>
  ),
  '4': ( // OTHER
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M10 7v3.5M10 13v.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  '5': ( // R-PANEL
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2 15 L10 6 L18 15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 12 L5 15 M8 9.5 L8 15 M11 9.5 L11 15 M14 12 L14 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  // Flat / membrane
  '6': ( // EPDM
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="7" width="16" height="7" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <rect x="5" y="10" width="10" height="1.5" rx=".75" fill="currentColor" opacity=".6"/>
    </svg>
  ),
  '7': ( // TPO
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="7" width="16" height="7" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M5 13.5 Q10 8 15 13.5" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round"/>
    </svg>
  ),
  '8': ( // PVC
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="7" width="16" height="7" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <line x1="5" y1="10.5" x2="15" y2="10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2.5 2"/>
    </svg>
  ),
  '9': ( // OTHER (flat)
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M10 7v3.5M10 13v.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  '17': ( // KEE
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="7" width="16" height="7" rx="2" fill="currentColor" opacity=".12" stroke="currentColor" strokeWidth="1.5"/>
      <rect x="5" y="9.5" width="4" height="3" rx=".8" fill="currentColor" opacity=".5"/>
      <rect x="11" y="9.5" width="4" height="3" rx=".8" fill="currentColor" opacity=".8"/>
    </svg>
  ),
  '18': ( // TPA
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="7" width="16" height="7" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      <path d="M5 10.5 L8 13 L11 8 L14 11.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  ),
  '19': ( // APP
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="6" width="16" height="3" rx="1.2" fill="currentColor" opacity=".8"/>
      <rect x="2" y="11" width="16" height="3" rx="1.2" fill="currentColor" opacity=".5"/>
      <rect x="2" y="16" width="16" height="1.5" rx=".75" fill="currentColor" opacity=".3"/>
    </svg>
  ),
  '20': ( // SBS
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="5.5" width="16" height="2.5" rx="1.2" fill="currentColor" opacity=".9"/>
      <rect x="2" y="9.5" width="16" height="2.5" rx="1.2" fill="currentColor" opacity=".65"/>
      <rect x="2" y="13.5" width="16" height="2.5" rx="1.2" fill="currentColor" opacity=".4"/>
    </svg>
  ),
  '21': ( // ACRYLIC
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 15 Q6 6 10 10 Q14 14 17 5" stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="10" cy="10" r="1.5" fill="currentColor" opacity=".6"/>
    </svg>
  ),
  '22': ( // COATED
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="8" width="16" height="6" rx="2" fill="currentColor" opacity=".15" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 11 Q7.5 8.5 10 11 Q12.5 13.5 15 11" stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinecap="round"/>
    </svg>
  ),
};

export const CheckIcon = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M1.5 4L3.5 6L6.5 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M3 3l8 8M11 3L3 11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);

export const PersonIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <circle cx="6.5" cy="4.5" r="2.5" stroke="currentColor" strokeWidth="1.3"/>
    <path d="M1.5 12c0-2.761 2.239-4 5-4s5 1.239 5 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

export const LocationPinIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M6.5 1C4.57 1 3 2.57 3 4.5c0 2.8 3.5 7 3.5 7S10 7.3 10 4.5C10 2.57 8.43 1 6.5 1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
    <circle cx="6.5" cy="4.5" r="1.25" stroke="currentColor" strokeWidth="1.2"/>
  </svg>
);

export const GeoResolvedIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.2"/>
    <path d="M3.5 6L5.5 8L8.5 4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* ── LiteNavbar icons ──────────────────────────────────── */

export const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const AvatarIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <circle cx="8.5" cy="6" r="3" stroke="#fff" strokeWidth="1.4" />
    <path d="M2 15c0-3.5 3-5.5 6.5-5.5S15 11.5 15 15" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const TemplatesIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M2 2h8l2 2v8H2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    <path d="M4 2v4h6V2M4 8h6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

export const LogoutIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M9 2h3v10H9M6 10l4-3-4-3M1 7h7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
